import { ReactNode } from 'react';

export enum FilePreviewFileInfoType {
  IMAGE = 'image',
  VIDEO = 'video',
  OTHER = 'other'
}

export interface FilePreviewFileInfoAction {
  icon: ReactNode | null;
  type: string;
}

export interface FilePreviewFileInfoData {
  icon: ReactNode | null;
  value: ReactNode | string | number;
}

export interface FilePreviewFileInfo {
  id?: string;
  type: FilePreviewFileInfoType;
  url: string;
  name?: string;
  actions?: FilePreviewFileInfoAction[];
  data?: FilePreviewFileInfoData[];
}

export interface FilePreviewProps {
  show: boolean;
  fileList: FilePreviewFileInfo[];
  onClose: () => void;
  className?: string;
  defaultIndex?: number;
  onIndexChange?: (current: FilePreviewFileInfo, index: number) => void;
  onClickAction?: (current: FilePreviewFileInfo, action: string) => void;
}
